module.exports = __webpack_public_path__ + "static/media/HeroFlow-Final-01.309294d8.svg";